import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { ArrowRight, Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  const { lang } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = lang === "de" ? "Seite nicht gefunden – Atlas Apartment" : "Page not found – Atlas Apartment";
  }, [lang]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-32 bg-[var(--cream)]">
      <p className="font-display text-8xl md:text-9xl font-medium text-[var(--terra)] mb-2">404</p>
      <h1 className="font-display text-2xl md:text-3xl font-medium text-[var(--ink)] mb-3">
        {lang === "de" ? "Diese Seite gibt es nicht (mehr)" : "This page doesn't exist"}
      </h1>
      <p className="text-[var(--muted)] text-sm max-w-md mb-8 leading-relaxed">
        {lang === "de"
          ? "Der Link ist vielleicht veraltet oder falsch geschrieben. Kein Problem — von hier geht's weiter:"
          : "The link may be outdated or mistyped. No problem — here's how to continue:"}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button onClick={() => navigate("/")} className="btn-primary justify-center">
          <HomeIcon size={15} /> {lang === "de" ? "Zur Startseite" : "Back to home"}
        </button>
        <button onClick={() => navigate("/apartments")} className="btn-outline justify-center">
          {lang === "de" ? "Apartments ansehen" : "View apartments"} <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
